import React, { useState, useRef } from 'react';
import axios from "axios";
import ReCAPTCHA from 'react-google-recaptcha';
import FormInput from "../../components/UI/Input";

const ContactForm = () => {
    const recaptchaRef = useRef(null);

    const [formData, setFormData] = useState({
        first_name: '',
        last_name: '',
        email_address: '',
        phone_no: '',
        con_message: ''
    });

    const [captchaToken, setCaptchaToken] = useState('');
    const [status, setStatus] = useState({ sending: false, message: '', success: null });

    const recaptchaSiteKey = "6LeeOLAsAAAAAAM0l7ev-f0KYNZAYdrz7WRpqXFN";

    const handleChange = (e) => {
        setFormData(prev => ({
            ...prev,
            [e.target.name]: e.target.value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!captchaToken) {
            setStatus({ sending: false, message: "Please complete captcha", success: false });
            return;
        }

        setStatus({ sending: true, message: "Sending...", success: null });

        try {
            const res = await axios.post("https://burgeon-grp.com/api/send-email", {
                ...formData,
                captcha_token: captchaToken
            });

            setStatus({ sending: false, message: res.data.message, success: true });

            setFormData({
                first_name: '',
                last_name: '',
                email_address: '',
                phone_no: '',
                con_message: ''
            });

            setCaptchaToken('');

            if (recaptchaRef.current) {
                recaptchaRef.current.reset();
            }

        } catch (err) {
            console.error(err);
            setStatus({ sending: false, message: "Failed to send ❌", success: false });
        }
    };

    return (
        <div className="contact-form-wrap">
            <form onSubmit={handleSubmit}>

                <FormInput
                    tag="input"
                    name="first_name"
                    placeholder="First Name *"
                    value={formData.first_name}
                    onChange={handleChange}
                    required
                />

                <FormInput
                    tag="input"
                    name="last_name"
                    placeholder="Last Name *"
                    value={formData.last_name}
                    onChange={handleChange}
                    required
                />

                <FormInput
                    tag="input"
                    type="email"
                    name="email_address"
                    placeholder="Email *"
                    value={formData.email_address}
                    onChange={handleChange}
                    required
                />

                <FormInput
                    tag="input"
                    name="phone_no"
                    placeholder="Phone"
                    value={formData.phone_no}
                    onChange={handleChange}
                />

                <FormInput
                    tag="textarea"
                    name="con_message"
                    placeholder="Message *"
                    value={formData.con_message}
                    onChange={handleChange}
                    required
                />

                <div className="mt-20 mb-20">
                    <ReCAPTCHA
                        ref={recaptchaRef}
                        sitekey={recaptchaSiteKey}
                        onChange={(token) => setCaptchaToken(token || '')}
                    />
                </div>

                <FormInput
                    tag="button"
                    type="submit"
                    classes="btn-outline"
                    disabled={status.sending}
                />

                {status.message && (
                    <div className={
                        status.success === true
                            ? "success"
                            : status.success === false
                                ? "error"
                                : ""
                    }>
                        {status.message}
                    </div>
                )}

            </form>
        </div>
    );
};

export default ContactForm;